export const articlesPath = "articles";
export const registerPath = "register";
export const loginPath = "login";
export const newArticlePath = "new-article";
export const profilePath = "profile";
export const editArticlePath = "articles/:slug/edit";
export const articlePath = "articles/:slug";
